<template>
  <v-list flat>
    <v-list-item v-for="(item, index) in items" :key="index" dense>
      <v-list-item-avatar class="list-avatar mb-0" size="30">
        <v-img v-if="item.profilePhoto" :src="item.profilePhoto"></v-img>
        <v-img v-else :src="noImage"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-if="item.firstName">
          <strong> {{ item.firstName + " " + item.lastName }}</strong>
        </v-list-item-title>
        <v-list-item-subtitle v-if="item.firstName">{{
          item.userEmail
        }}</v-list-item-subtitle>
        <v-list-item-title v-else>{{ item.userEmail }}</v-list-item-title>
        <v-list-item-subtitle>
          <strong>{{ getVotingLable(label) }}:</strong>
          {{ item.createdDate }}
        </v-list-item-subtitle>
        <v-list-item-subtitle class="wrap-text">
          <strong> {{ $t("agenda.lblComment") }}: </strong
          ><span>{{ item[attr] || "" }}</span>
        </v-list-item-subtitle>
        <v-divider class="mt-1" v-if="index <= items.length - 2"></v-divider>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import noImage from "@/assets/images/NoPhotoIcon.png";

export default {
  name: "VotingUserList",
  props: {
    items: Array,
    label: String,
    attr: {
      type: String,
      default: "votingComment",
    },
  },
  data() {
    return {
      noImage,
    };
  },
  methods: {
    getVotingLable,
  },
};

function getVotingLable(label) {
  switch (label) {
    case "approve":
      return this.$t("agenda.lblApprovedAt");
    case "abstain":
      return this.$t("agenda.lblAbstainedAt");
    case "reject":
      return this.$t("agenda.lblRejectedAt");
    case "hasObjection":
      return this.$t("agenda.lblObjectionRaisedAt");
    case "noObjection":
      return this.$t("agenda.lblNoObjectionAt");
    default:
      return "not found";
  }
}
</script>

<style scoped>
::v-deep .v-list-item__title {
  font-size: 15px !important;
}
.list-avatar {
  align-self: flex-start;
}
</style>